// Quita C0 (NUL, BEL, BS, …) y DEL; deja TAB y LF. CR se normaliza a LF en sanitizePlainText.
// eslint-disable-next-line no-control-regex -- intencional: sanitizar Excel/pegar, no un copy-paste accidental
const C0_EXCEPT_TAB_AND_LF = /[\u0000-\u0008\u000B\u000C\u000E-\u001F\u007F]/g;

export const sanitizePlainText = (value) => {
  if (typeof value !== 'string') {
    return value;
  }

  return value
    .replace(/\r\n/g, '\n')
    .replace(/\r/g, '\n')
    .replace(C0_EXCEPT_TAB_AND_LF, '');
};

export const sanitizeFormValuesInPlace = (values = {}) => {
  if (!values || typeof values !== 'object') {
    return values;
  }

  Object.keys(values).forEach((key) => {
    if (typeof values[key] === 'string') {
      values[key] = sanitizePlainText(values[key]);
    }
  });

  return values;
};
